import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CustomInput from "./CustomInput";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { forgotPassword } from "../../libs";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form?.email?.trim()) {
      toast.error("Email is required");
      return;
    }

    setLoading(true);
    try {
      const email = form.email.trim();
      const response = await forgotPassword(email);

      if (response) {
        toast.success("OTP sent to your email");
        setTimeout(() => {
          navigate(`/reset-password?email=${email}`, {
            state: {
              email,
            },
          });
        }, 2100);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="logpage bg-primaryC py-4 min-h-screen">
      <div className={`glass my-5  w-[320px] mx-auto `}>
        <h3 className="text-center text-3xl mb-2">Forgot Password</h3>
        <p className="text-center mb-4 xs:text-[15px]  text-[12px]">
          Enter your email to reset your password
        </p>
        <form onSubmit={handleSubmit}>
          <CustomInput
            type="text"
            label="Email Address"
            id="email"
            required="required"
            onChange={handleChange}
          />

          <div className="mb-3 text-right text-xs">
            {/* {!isSignup && <Link to='/forgot-password' className='font-bold'>Login</Link>} */}
          </div>
          <button
            className="rounded-2xl px-3 py-2 bg-indigo-500 text-white font-medium w-100 text-center text-decoration-none fs-5"
            type="submit"
            disabled={loading}
            onClick={handleSubmit}
          >
            {loading ? "Sending..." : "Send OTP"}
          </button>
          <div className="text-xs mt-3 text-center">
            <p>
              ALready have an account?
              <Link to="/login" className="font-bold cursor-pointer text-right">
                {" "}
                Login
              </Link>
            </p>
          </div>
        </form>
      </div>
      <ToastContainer autoClose={2000} theme="colored" newestOnTop={true} />
    </div>
  );
};

export default ForgotPassword;
